export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/083542a5e35ba09279ec63b521a0a3af.jpg"
          alt="Gang Nam Style Karaoke Interior"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="space-y-8">
          <h1 className="text-7xl md:text-8xl font-bold text-white leading-tight">
            Sing Your<br />Heart Out
          </h1>
          <p className="text-3xl text-pink-400 font-semibold italic">
            Every Night is Show Night
          </p>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
            Experience live karaoke, craft cocktails, and unforgettable vibes in Duluth's premier entertainment venue
          </p>
          <div className="flex items-center justify-center gap-6 pt-4">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-pink-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-pink-700 transition-all hover:scale-105 shadow-2xl whitespace-nowrap"
            >
              Book Your Table
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className="border-2 border-pink-500 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-pink-500/20 transition-all hover:scale-105 whitespace-nowrap"
            >
              View Menu
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white"></i>
      </div>
    </section>
  );
}
